
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/documentServices/dsDebugTools/dsDebugger.scss.css.virtualfile';
        module.exports = {"container":"_container_1ujlx_1"};